import {GuruEntity} from "../model/guru-entity";

export class PricingGroup {

  readonly groupName: string;
  readonly selectionNames: string[];
  private selections: GuruEntity[];

  constructor(groupName: string, selectionNames: string[]) {
    this.groupName = groupName;
    this.selectionNames = selectionNames;
    this.selections = [];
  }

  addSelection(entity: GuruEntity): void {
    this.selections.push(entity);
  }

  clearSelections(): void {
    this.selections = [];
  }

  getSelections(): GuruEntity[] {
    return this.selections;
  }

}
